import styled from 'styled-components';
import { colorCSS, zIndex } from '../../styles';
export const Header = styled.header `
  background-color: ${({ backgroundColor, backgroundColorFixed, hasScrolled }) => colorCSS(hasScrolled ? backgroundColorFixed : backgroundColor)};
  box-shadow: ${({ hasScrolled }) => hasScrolled ? 'rgba(0, 0, 0, 0.3) 0px 0px 10px 0px' : 'none'};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 72px;
  padding: 1rem;
  position: fixed;
  transition: all 500ms ease-out;
  width: 100%;
  z-index: ${zIndex.header};
  a {
    color: ${({ linkColor }) => colorCSS(linkColor)};
    &:hover {
      color: ${({ linkColorHover }) => colorCSS(linkColorHover)};
    }
  }
`;
//# sourceMappingURL=UiHeader.styles.js.map